import { Table } from 'antd';
import { applicationUrl, capitalize, formatFilePath, formatMoney, getRandomColor } from '../../../utils';
import moment from 'moment';
import useFetch from '../../../custom_hooks/useFetch';
import TableLoading from '../../../components/TableLoading';
import useFilterArray from '../../../custom_hooks/useFilterArray';
import { useEffect } from 'react';
import { debitNoteTypeColor } from '../../../data';

export default function AllTransactionStatementTable() {
    const { data, isLoading } = useFetch(`${applicationUrl().url}/api/v1/transactions/group`);

    const { filterArray, handleFilter } = useFilterArray(data);

    useEffect(() => {
        handleFilter(data);
    }, [data]);

    useEffect(() => {}, [filterArray]);

    if (isLoading) return <TableLoading />;

    const columns = [
        {
            title: 'Date',
            dataIndex: 'createdAt',
            render: (item) => <span>{moment(item).format('Do MMMM YYYY')}</span>,
        },
        {
            title: 'Member',
            render: (item) => (
                <>
                    <div className="w-full flex items-center gap-[.5rem]">
                        <img
                            src={item?.gpmProfilePhoto
                                ? formatFilePath(item?.gpmProfilePhoto)
                                : `https://ui-avatars.com/api/?name=${encodeURIComponent(item?.gpmName)}&background=${getRandomColor()}&color=fff`}
                            className="w-[2.1875rem] h-[2.1875rem] rounded-full object-cover"
                            alt="avatar"
                        />
                        <span>{item?.gpmName}</span>
                    </div>
                </>
            ),
        },
        {
            title: 'Activity',
            dataIndex: 'trxSource',
            render: (item) => {
                const roleColor = debitNoteTypeColor.find((role) => String(role.label).toUpperCase() === String(item).toUpperCase())?.value || '#F6F6F6'
    
                return (
                    <div
                        style={{
                            background: roleColor,
                        }}
                        className="flex w-full min-h-[1.8rem] h-auto items-center justify-center gap-[.5rem] px-[.5rem] py-[.25rem]"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="4" viewBox="0 0 5 4" fill="none">
                            <circle cx="2.66602" cy="2" r="2" fill="#212121" />
                        </svg>
                        <span>{capitalize(item?.split('_').join(' '))}</span>
                        </div>
                );
            },
        },
        
        // {
        // 	title: 'Ref no.',
        // 	dataIndex: 'trxRef',
        // },
        {
            title: 'Debit (KES)',
            render: (item) => {
                const { trxType, trxAmount } = item;
                if (trxType === 'DEBIT') {
                    return <span>{formatMoney(Math.abs(trxAmount), 'KES')}</span>;
                }
                return <span>-</span>;
            },
        },
        {
            title: 'Credit (KES)',
            render: (item) => {
                const { trxType, trxAmount } = item;
                if (trxType === 'CREDIT') {
                    return <span>{formatMoney(Math.abs(trxAmount), 'KES')}</span>;
                }
                return <span>-</span>;
            },
        },
    ];

    return (
        <>
            <Table
                rowKey="trxRef"
                className="mt-[1.5rem] !w-full"
                columns={columns}
                dataSource={data}
                scroll={{
                    x: 1200,
                }}
                pagination={{
                    defaultPageSize: 7,
                    hideOnSinglePage: true,
                    pageSizeOptions: [10, 20, 50, 100],
                }}
            />
        </>
    );
}
